// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610121833/js/" + chunkId + "." + {"44":"27292d5c","225":"79715dc2","481":"c4f10acb","486":"6efd2dcf","770":"f696aaad"}[chunkId] + ".0.3304340297225682.chunk.js";
};